<template>
  <b-modal
    ref="modal"
    size="xl"
    header-class="anchor-modal"
    title="Change Order Request"
    id="changeOrderModal"
    scrollable
    no-close-on-backdrop
    hide-footer
  >
    <action-modal-wizard-header ref="header" :loan="loan" />
    <estimate-of-repairs
      ref="estimateOfRepairs"
      :loan="loan"
      :isChangeOrder="true"
    />
    <div class="mt-3 mb-2 text-right">
      <b-button
        size="md"
        class="btn-anchor raised"
        @click="save"
      >
        Save
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import ActionModalWizardHeader from '@/components/my_deals/actions/ActionModalWizardHeader';
import EstimateOfRepairs from '@/components/my_deals/actions/estimate_of_repairs/EstimateOfRepairs';

export default {
  name: 'ChangeOrderWizardModal',
  components: {
    ActionModalWizardHeader,
    EstimateOfRepairs,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.estimateOfRepairs.reset();
      this.$refs.modal.hide();
    },
    save() {
      const changeOrder = this.$refs.estimateOfRepairs;
      if (!changeOrder.validate()) {
        this.$notify({ group: 'alert', text: 'Please verify all missing fields.', type: 'error' });
        return;
      }
      const user = this.$store.getters.user;
      const loan = this.loan;
      /* eslint no-underscore-dangle:  ["error", { "allow": ["_id"] }] */
      this.$reqs.post(`/users/${user.id}/loans/${loan._id}/change_order`, changeOrder.model)
        .then((response) => {
          this.$notify({ group: 'alert', duration: 3000, text: 'Change Order saved successfully.' });
          this.$emit('on-save', response);
          this.hide();
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/my_deals/actions/change_order/ChangeOrderWizardModal.vue